/* eslint-disable react/display-name */
import React from "react";
import { find, isEmpty, get } from "lodash";

import { useUser } from "../contexts/user";

export default function useCurriculum() {
  const { user } = useUser();

  const curriculum = React.useMemo(() => {
    if (!user?.isLoggedIn || !user?.features?.curriculum) {
      return undefined;
    }

    const classroomWithCurriculum = find(
      user?.classrooms,
      (classroom) =>
        classroom.id === user?.selectedClassroomId &&
        !isEmpty(classroom.curriculumAccesses) &&
        !isEmpty(classroom.curriculums),
    );

    return get(classroomWithCurriculum, "curriculums[defaultCurriculum]");
  }, [
    user?.classrooms,
    user?.features?.curriculum,
    user?.isLoggedIn,
    user?.selectedClassroomId,
  ]);

  return curriculum;
}
